<template>
  <form class="widerruf-form" novalidate @submit.prevent="submit">
    <h3>Widerruf einreichen</h3>

    <div class="form-row">
      <label class="fl" for="w-name">Dein Name</label>
      <input
        id="w-name"
        v-model.trim="form.name"
        type="text"
        placeholder="Vor- und Nachname"
        autocomplete="name"
        :class="{ 'has-error': errors.name }"
      />
      <span v-if="errors.name" class="field-error">{{ errors.name }}</span>
    </div>

    <div class="form-row">
      <label class="fl" for="w-email">E-Mail-Adresse</label>
      <input
        id="w-email"
        v-model.trim="form.email"
        type="email"
        placeholder="du@beispiel.de"
        autocomplete="email"
        :class="{ 'has-error': errors.email }"
      />
      <span v-if="errors.email" class="field-error">{{ errors.email }}</span>
    </div>

    <div class="form-row">
      <label class="fl" for="w-datum">Bestelldatum</label>
      <input
        id="w-datum"
        v-model.trim="form.orderDate"
        type="text"
        placeholder="z.B. 14. März 2026"
        :class="{ 'has-error': errors.orderDate }"
      />
      <span v-if="errors.orderDate" class="field-error">{{ errors.orderDate }}</span>
    </div>

    <div class="form-row">
      <label class="fl" for="w-grund">Anmerkung (optional)</label>
      <textarea
        id="w-grund"
        v-model.trim="form.note"
        placeholder="Du musst keinen Grund angeben — aber falls du magst…"
      ></textarea>
    </div>

    <p class="widerruf-note">
      Mit dem Absenden bestätigst du, dass du den Vertrag mit THE-FARIN LTD
      widerrufen möchtest. Wir bestätigen den Eingang per E-Mail.
    </p>

    <p v-if="serverError" class="field-error">{{ serverError }}</p>

    <button type="submit" class="btn btn-primary" :disabled="submitting">
      {{ submitting ? 'Wird gesendet…' : 'Widerruf absenden' }}
      <span aria-hidden="true">→</span>
    </button>
  </form>
</template>

<script>
import axios from 'axios';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'WithdrawalForm',
  data() {
    return {
      form: { name: '', email: '', orderDate: '', note: '' },
      errors: {},
      serverError: '',
      submitting: false,
    };
  },
  methods: {
    validate() {
      const errors = {};
      if (!this.form.name) {
        errors.name = 'Bitte gib deinen Namen ein.';
      }
      if (!this.form.email) {
        errors.email = 'Bitte gib deine E-Mail-Adresse ein.';
      } else if (!EMAIL_RE.test(this.form.email)) {
        errors.email = 'Bitte gib eine gültige E-Mail-Adresse ein.';
      }
      if (!this.form.orderDate) {
        errors.orderDate = 'Bitte gib das Bestelldatum ein.';
      }
      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    reset() {
      this.form = { name: '', email: '', orderDate: '', note: '' };
      this.errors = {};
      this.serverError = '';
    },
    async submit() {
      if (this.submitting || !this.validate()) {
        return;
      }
      this.submitting = true;
      this.serverError = '';

      const email = this.form.email;

      try {
        const token = document.head.querySelector('meta[name="csrf-token"]');
        await axios.post(
          '/ajax/withdrawal',
          {
            name: this.form.name,
            email,
            order_date: this.form.orderDate,
            note: this.form.note || null,
          },
          {
            headers: {
              'X-CSRF-TOKEN': token ? token.content : '',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        );

        this.reset();
        if (window.toast && window.toast.success) {
          window.toast.success('Widerruf eingereicht', {
            description: `Bestätigung folgt an ${email}.`,
          });
        }
      } catch (error) {
        const response = error.response;
        if (response && response.status === 422 && response.data.errors) {
          const serverErrors = response.data.errors;
          this.errors = {
            name: (serverErrors.name || [])[0],
            email: (serverErrors.email || [])[0],
            orderDate: (serverErrors.order_date || [])[0],
          };
        } else {
          this.serverError =
            'Etwas ist schiefgelaufen. Bitte versuch es später erneut.';
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.field-error {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: var(--rose);
}

.has-error {
  border-color: var(--rose);
}
</style>
